import { useStyleSheet } from '../../../../hooks/useStyleSheet';

export const useStyles = () => {
  const styles = useStyleSheet(
    (theme) => ({
      root: {
        display: 'flex',
        gap: theme.spacing.secondary,
        alignItems: 'center',
        justifyContent: 'space-between',
      },
      options: {
        display: 'flex',
        gap: theme.spacing.secondary,
        alignItems: 'center',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
      },
    }),
    [],
  );

  return styles;
};
